import React, { useState, useEffect } from "react"; 

import LoaderforHomePage from '../src/components/LoaderforHomePage.js';
import Header from '../src/components/Header';
import Footer from '../src/components/Footer';
import Slider from '../src/components/Slider';

//import VisaProducts from './products/VisaProducts';
import VisaPage from "../src/products/VisaPage";
import VisaBtn from '../src/components/buttons/VisaBtn.js';

//import TourProducts from './products/TourProducts';
import ActivityPage from "./products/ActivityPage";
import TourBtn from '../src/components/buttons/TourBtn';



//import DestinationProducts from './products/DestinationProducts';
import DestinationPage from "./products/DestinationPage";
import DestinationsBtn from '../src/components/buttons/DestinationsBtn';


import WhatsApp from '../src/components/WhatappPlugin'
import NewsLetter from "./components/NewsLetter";

import '../src/custom.scss';

//go to top if any any new page render
import GoToTop from './components/GoToTop'; 


function App() {

const [loading, setLoading] = useState(
    !sessionStorage.getItem("loaderShown")
  );

  useEffect(() => {
    if (!sessionStorage.getItem("loaderShown")) {
      const handleLoad = () => {
        setTimeout(() => {
          setLoading(false);
          sessionStorage.setItem("loaderShown", "true");
        }, 800);
      };

      if (document.readyState === "complete") {
        handleLoad();
      } else {
        window.addEventListener("load", handleLoad);
        return () => window.removeEventListener("load", handleLoad);
      }
    } else {
      setLoading(false);
    }
  }, []);


  if (loading) {
    return <LoaderforHomePage />;
  }



  return (
    <div className="App">

<>

<Header /> 
<Slider /> 

<DestinationPage />
<DestinationsBtn /> 

<VisaPage /> 
<VisaBtn /> 

<ActivityPage />
<TourBtn />
<WhatsApp />    

<NewsLetter />  


<Footer />  

    <GoToTop />   
</>

  </div>
  );
}

export default App;
